var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"responsive-iframe",staticStyle:{"border":"0"},attrs:{"src":_vm.homeDashboard,"frameborder":"0","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }